// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b409dadd","320":"33b2341b","455":"3e466cec","935":"578050f2"}[chunkId] + ".chunk.js";
};